<template>
    <div id="app">
      <HeaderComponent :title="title" :step="step" />
      <main>
        <router-view />
      </main>
    </div>
  </template>
  
  <script>
  import HeaderComponent from '@/components/Header.vue';
  
  export default {
    name: 'MainLayout',
    components: {
      HeaderComponent
    },
    data() {
      return {
        title: '',
        step: 0
      };
    },
    watch: {
      $route(to) {
        this.title = to.meta.title;
        this.step = to.meta.step;
        console.log('Current Step:', this.step);
        console.log('Completed Steps:', this.step > 1 ? this.step - 1 : 0);
       
      }
    },
    created() {
      this.title = this.$route.meta.title;
      this.step = this.$route.meta.step;
      console.log('Current Step:', this.step);
      console.log('Completed Steps:', this.step > 1 ? this.step - 1 : 0);
     
    }
  };
  </script>
  
  <style>z
  /* Global styles */
  body {
    margin: 0;
    padding: 0;
    background-color: #f4f4f4;
  }
  
  #app {
    text-align: center;
  }

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  </style>
  